import { Component, inject } from '@angular/core';
import { TeamRosterComponent } from "../../components/team-roster/team-roster.component";
import { ActivatedRoute } from '@angular/router';
import { TeamService } from '../../../shared/services/team.service';
import { CommonModule, Location } from '@angular/common';
import { ScoutingTeamViewModel } from '../../../shared/models/TeamModels';
import { TeamHeaderComponent } from "../../components/team-header/team-header.component";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { toSignal } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-team-details',
  imports: [
      CommonModule,
      TeamRosterComponent, TeamHeaderComponent,
      MatToolbarModule, MatIconModule, MatTabsModule, MatDividerModule, MatListModule, MatButtonModule, MatProgressBarModule,
      TranslateModule
    ],
  templateUrl: './team-details.component.html',
  styleUrl: './team-details.component.css',
})
export class TeamDetailsComponent {

  private activatedRoute = inject(ActivatedRoute);
  private teamService = inject(TeamService);
  private location = inject(Location);
  private router = inject(Router);

  Team = toSignal<ScoutingTeamViewModel>(
    this.activatedRoute.params.pipe(
      switchMap(params => this.teamService.getScoutingTeamDetails(params['TeamId']))
    )
  );

  back() {
    this.location.back();
  }

  openGameDetails(gameId: string) {
    this.router.navigate(['/scouting/gamedetails', gameId]);
  }
}
